/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addRestriction} from '../api'

export const useMutationAddRestriction = createReactQueryMutationHook('addRestriction', addRestriction)
